import moment from 'moment';
import 'moment/locale/nl';

moment.locale('nl');

const PERIOD_LIKE_CHARS = ['.', '?', '!'];

export function addPeriod(str) {
    if (PERIOD_LIKE_CHARS.includes(str.slice(-1))) {
        return str;
    } else {
        return str + '.';
    }
}

// A wrapper around moment.js, because things are complicated
export function datetime(isoString = null) {
    if (!isoString) {
        return null;
    }

    // Do we have hour / minute?
    const hasTime = isoDateHasTime(isoString);

    const m = moment(isoString);

    return {
        dateFormatted : m.format('dd D MMM').replace('.', ''),
        hasTime : hasTime,
        moment : m,
        timeFormatted : hasTime ? m.format('H:mm') : null
    }
}

export function formatLanguage(code) {
    const lang = getLanguageCode(code);

    if (lang === 'nl') {
        return 'In het Nederlands';
    } else if (lang === 'en') {
        return 'In English';
    } else {
        return lang;
    }
}

export function getLanguageCode(code) {
    return code.split('-').shift().toLowerCase();
}

// TOOD: replace with moment
// .toISOString() doesn't take time zones into account :/
// https://stackoverflow.com/a/28149561/152809
export function getIsoDate(days = 0) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);
    return localISOTime;
}

export function isoDateHasTime(isoString) {
    return isoString.includes('T');
}

// TODO: find some way to include these functions from lodash without adding 200kb
// to the build
export function random(min, max) {
    return Math.round(Math.random() * max) - min;
}

export function randomColor() {
    const r = random(0, 255);
    const g = random(0, 255);
    const b = random(0, 255);

    return `rgb(${r}, ${g}, ${b})`;
}

export function wordConcat(words, concatter) {
    words = words.map((word, index) => {
        if (index === words.length - 2) {
            return `${word} `;
        } else if (index === words.length - 1) {
            return `${concatter} ${word}`
        } else {
            return `${word}, `;
        }
    });

    return words.join('');
}